<template>
    <div style="display: flex; flex-direction: column; width: 100%; color: #fff; align-items: center; background: #020202; padding: 20px 0">
      <slot name="footerImage"></slot>
      <div>Copyright © 2022 至简数产 All Rights Reserved 赣ICP备2023012026号-4 网安备31010402333773号</div>
    </div>
</template>

<script>
import { getagreelist } from "../network/home.js";
export default {
  data() {
    return {
      registerTerms: [],
    };
  },
  created() {
    this.getagreelist();
  },
  methods: {
    //获取协议
    async getagreelist() {
      //会员服务协议
      let res = await getagreelist("CONTACT_US_KEY");
      if (res.status === 0) {
        this.registerTerms = res.data;
      }
    },
    goTo(url, index, id) {
      this.$router.push({ path: url, query: { indexs: index, id: id } }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
    goToUs() {
      this.$router.push({ path: "/contactus", query: { id: this.registerTerms[0].id, key: "CONTACT_US_KEY" } });
    },
  },
};
</script>
<style scoped>
.footer {
  height: 130px;
  position: relative;
  margin-top: 20px;
  display: flex;
}
.bottom_logo4 {
  width: 115px;
  height: 59px;
  position: absolute;
  top: 45px;
  left: 220px;
}
.bottom_link4 ul {
  padding: 0;
  margin: 0;
}
.bottom_link4 li {
  float: left;
  color: #fff;
  padding: 0 22px;
  font-size: 14px;
  list-style: none;
  line-height: 26px;
  display: flex;
  align-items: center;
}
.weibo-icon,
.wechat-icon {
  position: relative;
}
.bottom_link4 .wechat-icon i {
  display: block;
  width: 30px;
  height: 25px;
  background: url("../assets/images/wechat.png") no-repeat;
}
.wechat-icon:hover .qrcode-b {
  display: block;
}
.bottom_link4 .weibo-icon i {
  display: block;
  width: 30px;
  height: 25px;
  background: url("../assets/images/weibo.png") no-repeat;
}
.weibo-icon:hover .qrcode-b {
  display: block;
}
.bottom_link4 .fb-icon i {
  display: block;
  width: 30px;
  height: 30px;
  background: url("../assets/images/fb.png") no-repeat;
}
.bottom_link4 .ig-icon i {
  display: block;
  width: 30px;
  height: 30px;
  background: url("../assets/images/ig.png") no-repeat;
}
.bottom_link4 li a {
  line-height: unset !important;
}
.homepic {
  margin-right: 5px;
  margin-top: -5px;
}
.bottom_link4 {
  position: absolute;
  top: 65px;
  left: 505px;
}
.qrcode-b {
  display: none;
  position: absolute;
  top: -95px;
  left: -10px;
}
.mail {
  position: absolute;
  top: 65px;
  left: 1050px;
  color: #fff;
  font-size: 14px;
}
.bottom-icp {
  width: 400px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 20px;
}
.bottom-icp a {
  color: #fff;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue